import { render, staticRenderFns } from "./AgenciesTab.vue?vue&type=template&id=6148450d&scoped=true&"
import script from "./AgenciesTab.vue?vue&type=script&lang=js&"
export * from "./AgenciesTab.vue?vue&type=script&lang=js&"
import style0 from "./AgenciesTab.vue?vue&type=style&index=0&id=6148450d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6148450d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VContainer,VDataTable,VSwitch})
